import { Suspense } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { Loader } from '@givebutter/primitives/loader';
import { faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReportHistoryTable } from 'components/pages/contacts/components/ReportHistoryTable';

interface ExportReportsHistoryProps extends AlertDialog.AlertDialogRootProps {
    onClose?: () => void;
}

const ExportReportsHistory = ({ open, onClose, ...rest }: ExportReportsHistoryProps) => {
    return (
        <AlertDialog.Root open={open} {...rest}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content onEscapeKeyDown={onClose} className="max-w-xl">
                    <AlertDialog.Header>
                        <div
                            className={
                                'flex h-12 w-12 flex-col items-center justify-center rounded-full bg-gray-100 text-center align-middle text-gray-500'
                            }
                        >
                            <FontAwesomeIcon
                                className={'flex h-5 w-5'}
                                icon={faClockRotateLeft}
                                fill={'text-gray-500'}
                            />
                        </div>
                        <AlertDialog.Close onClick={onClose} />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Export History</AlertDialog.Title>
                        <AlertDialog.Description>
                            <p>View and redownload previously exported reports.</p>
                        </AlertDialog.Description>
                        <div
                            className={`bg-gray-25 flex min-h-[20rem] flex-col gap-4 overflow-auto rounded-md border-2 border-gray-200 pb-3`}
                        >
                            <Suspense fallback={<Loader />}>
                                <ReportHistoryTable />
                            </Suspense>
                        </div>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel onClick={onClose}>Close</AlertDialog.Cancel>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const ExportReportsHistoryTrigger = AlertDialog.Trigger;

const Root = ExportReportsHistory;
const Trigger = ExportReportsHistoryTrigger;

export {
    ExportReportsHistory,
    ExportReportsHistoryTrigger,
    //
    Root,
    Trigger,
};
export type { ExportReportsHistoryProps };
